// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonSortSortAz_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 1H3V8H5L2.5 12L0 8H2V1Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 5.90137H10.7969L10.4482 4.81104H8.70508L8.35986 5.90137H7.16357L8.94775 1H10.2568L12 5.90137ZM10.1953 3.96338L9.66895 2.31592C9.63021 2.19287 9.60286 2.0459 9.58691 1.875H9.55957C9.54818 2.01855 9.51969 2.16097 9.47412 2.30225L8.94092 3.96338H10.1953Z" class="svg-bg"/>
  <path d="M7.55225 12H11.5V11.1045H9.03564L11.4932 7.71729V7.09863H7.7334V7.99756H10.0645L7.55225 11.3643V12Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 10H20.2587L19.7541 8.44238H17.2311L16.7314 10H15L17.5823 2.99805H19.477L22 10ZM19.388 7.23145L18.6261 4.87793C18.5701 4.70215 18.5305 4.49219 18.5074 4.24805H18.4678C18.4514 4.45312 18.4101 4.65658 18.3442 4.8584L17.5724 7.23145H19.388Z" class="svg-bg"/>
  <path d="M21.6396 21H16V20.0918L19.5889 15.2822H16.2588V13.998H21.6299V14.8818L18.1191 19.7207H21.6396V21ZM6 3H8V15H12L7 21 2 15H6V3Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonSortSortAz is a generated icon component.
 */
let IconCommonSortSortAz = IconCommonSortSortAz_1 = class IconCommonSortSortAz extends IconBaseElement {
    render() {
        return html `${IconCommonSortSortAz_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonSortSortAz.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonSortSortAz = IconCommonSortSortAz_1 = __decorate([
    customElement('zui-icon-common-sort-sort-az')
], IconCommonSortSortAz);
export { IconCommonSortSortAz };
